import React, { useState, useEffect, useRef } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../common/Footer";
import Sidebar from "../../common/Sidebar";
import Header from "../../common/Header";
import PageHeader from "../PageHeader";
import { Controller, useForm } from "react-hook-form";
import * as html2pdf from "html2pdf.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  ConfirmationAlert,
  capitalizeFirst,
  exportToCsv,
  formatDate,
  getToken,
  get_user_menu_permission,
  pageReload,
  simpleAlert,
  triggerAlert,
} from "../../utils";
import axios from "axios";
import { Button, Card, Table } from "react-bootstrap";
import Loader from "../../common/Loader";
import Pagination from "../PaginationComponent";
import AutoUserSearch from "../AutoUserSearch";
import companyLogo from "./companyLogo.png";
import companyLogo2 from "./logo.png";
import AutoSearchSelect from "../CommonSelectDynamic";
import CommonSelect from "../CommonSelectStatic";
import { cardType, invoiceStatus, invoiceType, menuIdData } from "../../utils/constants";
import PdfGen from "./PdfGen";
import DataTable from 'react-data-table-component';
import Cookies from "js-cookie";
import dayjs from "dayjs";
import { PictureAsPdf } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
export default function Invoices() {
  document.title = "Digital Employees - Invoice"
  const api_url = process.env.REACT_APP_API_BASE_URL;
  const customer_api_url = process.env.REACT_APP_API_CUSTOMER_URL;
  const show50Entries = process.env.REACT_APP_API_SHOW_ENTRIES;
  const token = Cookies.get('admin_user_token');

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
    control,
  } = useForm();
  const {
    register: registerUpdate,
    handleSubmit: handleSubmitUpdate,
    formState: { errors: errorsUpdate },
    setValue: setValueUpdate,
    control: controlUpdate,
    watch: watchUpdate,
    reset: resetUpdate,
  } = useForm();
  const reportTemplateRef = useRef(null);
  const reportTemplateRef2 = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSent, setIsLoadingSent] = useState(false);
  const [selectedTab, setSelectedTab] = useState("");
  const [isSearchBtnDisabled, setIsSearchBtnDisabled] = useState(true);
  const [downloadPDF, setDownloadPDF] = useState(false);
  const [data, setData] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalPlansCost, setTotalPlansCost] = useState(0);
  const [invoiceTotalCost, setInvoiceTotalCost] = useState(0);
  const [invoiceHtml, setInvoiceHtml] = useState("");
  const [customerId, setcustomerId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const currentDate = new Date();
  const [totalRows, setTotalRows] = useState(0);
  const [showsampleInvoice, setshowsampleInvoice] = useState(false)
  const [perPage, setPerPage] = useState(10);
  const [period_start, setPeriodStart] = useState("");
  const [period_end, setPeriodEnd] = useState("");
  const [minEndDate, setMinEndDate] = useState(
    period_start ? new Date(period_start) : null
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [pageSlNo, setPageSlNo] = useState(0);
  const [perPageLimit, setPerPageLimit] = useState(10);
  const [pageLimitSelected, setPageLimitSelected] = useState(10);

  const [showUpdatePage, setShowUpdatePage] = useState(false);
  const [invoice_Id, setInvoiceId] = useState(0);
  const [userPaymentDetails, setUserPaymentDetails] = useState([]);
  const [servicesList, setServicesList] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const action = queryParams.get("action");
  const { state } = location;

  const mainHeading = `${showUpdatePage
    ? `Update Invoice - ${userPaymentDetails?.invoice_number}`
    : "Invoice"
    }`;
  const heading = "Billing / Invoices";
  const [sendInvoiceId, setSendInvoiceId] = useState(null);
  const [sendCustomerId, setSendCustomerId] = useState(null);
  // Menu Permissions
  //  const [addPermission, setAddPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  //  const [deletePermission, setDeletePermission] = useState(false);
  const [exportPermission, setExportPermission] = useState(false);
  const [selectedInvoiceData, setselectedInvoiceData] = useState({})
  const [selectcustomer_add_info, setselectcustomer_add_info] = useState({})
  const [selectbilling_info, setselectbilling_info] = useState([])
  const [downloadsendmail, setdownloadsendmail] = useState(false)

  const invoice = selectedInvoiceData || null;

  const columns = [
    {
      name: 'S.No', sortable: true,
      width: "90px",
      selector: (row, index) => index + 1,
      cell: (row, index) => <>
        <span>{index + 1}</span>
      </>,
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">User</label>,
      sortable: true,
      selector: row => row.user_name,
      cell: row =>
        <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
          {row.user_name || '--'}
        </div>,
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">Email</label>,
      sortable: true,
      selector: row => row.user_email,
      cell: row =>
        <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
          {row.user_email || '--'}
        </div>,
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">Transaction Type</label>,
      sortable: true,
      selector: row => row.transaction_type,
      cell: row => {
        const typeColors = {
          purchase: { bg: '#d4edda', color: '#155724' },
          deduction: { bg: '#f8d7da', color: '#721c24' },
          topup: { bg: '#cce5ff', color: '#004085' },
        };
        const style = typeColors[row.transaction_type] || { bg: '#e2e3e5', color: '#383d41' };
        return (
          <span style={{
            padding: '3px 10px',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: '600',
            backgroundColor: style.bg,
            color: style.color
          }}>
            {row.transaction_type ? row.transaction_type.charAt(0).toUpperCase() + row.transaction_type.slice(1) : '--'}
          </span>
        );
      },
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">Amount</label>,
      sortable: true,
      selector: row => row.amount,
      cell: row =>
        <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
          {row.amount ? `$ ${parseFloat(row.amount).toFixed(2)}` : '--'}
        </div>,
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">Balance After</label>,
      sortable: true,
      selector: row => row.balance_after,
      cell: row =>
        <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
          {row.balance_after ? parseFloat(row.balance_after).toFixed(2) : '--'}
        </div>,
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">Description</label>,
      sortable: true,
      selector: row => row.description,
      cell: row =>
        <div className="DarkBlue4_Color font_weight_300 font_16 align-middle" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
          {row.description || '--'}
        </div>,
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">Source</label>,
      sortable: true,
      selector: row => row.source,
      cell: row =>
        <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
          {row.source || '--'}
        </div>,
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">Date</label>,
      sortable: true,
      selector: row => row.created_at,
      cell: row =>
        <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
          {row.created_at ? dayjs(row.created_at).format('MM-DD-YYYY HH:mm') : '--'}
        </div>,
    },
    {
      name: <label className="DarkBlue4_Color font_weight_500 font_14">Action</label>,
      sortable: false,
      selector: row => row.id,
      cell: row =>
        <>
          <div className="btn-group col-md-1">
            <button
              className="btn btn-sm btn-default p-0 mx-1"
              title="View"
              onClick={() => { setshowsampleInvoice(true); onloadembededdata(row); setselectedInvoiceData(row); }}
            >
              <i className="fas fa-solid fa-eye"></i>
            </button>

            <button
              className="btn btn-sm btn-default p-0 mx-1"
              title="Download"
              onClick={() => { onloadembededdata(row); downloadInvoiceAsPDF(row); setIsLoadingSent(true); setdownloadsendmail(true); }}
            >
              <i className="fas fa-arrow-alt-circle-down"></i>
            </button>

            <button
              className="btn btn-sm btn-default p-0 mx-1"
              title="Send mail"
              onClick={() => { onloadembededdata(row); setIsLoadingSent(true); setdownloadsendmail(true); setTimeout(() => { generatePDFAndSend(row); }, 1000); }}
            >
              <i className="fas fa-envelope-open-text"></i>
            </button>
          </div>
        </>,
    },
  ];

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#064c77",
        borderBottom: "1px solid #dee2e6",
        minHeight: "52px",
      },
    },
    headCells: {
      style: {
        color: "#ffffff",
        fontSize: "13px",
        fontWeight: "700",
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        minHeight: "56px",
        backgroundColor: "#ffffff",
        "&:hover": {
          backgroundColor: "#f8f9fa",
          cursor: "pointer",
          transition: "all 0.2s ease",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#495057",
        borderBottom: "1px solid #f1f3f5",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #dee2e6",
        padding: "8px",
      },
    },
    noData: {
      style: {
        backgroundColor: "#ffffff",
        color: "#6c757d",
        padding: "24px",
      },
    },
  };
  const [customerid, setcustomerid] = useState()
  const [invoiceid, setinvoiceid] = useState()
  const onloadembededdata = (row) => {
    setcustomerid(row.customer__id)
    setinvoiceid(row.id)
    setselectedInvoiceData(row);

    // guard against undefined / non-array values before accessing index 0
    if (Array.isArray(row?.customer_add_info) && row.customer_add_info.length > 0) {
      setselectcustomer_add_info(row.customer_add_info[0]);
    } else {
      setselectcustomer_add_info({});
    }

    // ensure billing_info is an array before setting it
    if (Array.isArray(row?.billing_info) && row.billing_info.length > 0) {
      setselectbilling_info(row.billing_info);
    } else {
      setselectbilling_info([]);
    }
  }


  const fetchInvoicesList = async (page_number, page_size = perPageLimit, searchkey, data) => {
    // if (action !== 'frm_dash') removeActionQueryParam();
    setIsLoading(true);

    console.log(data)
    try {
      let apiUrl = `/api/admin/billing/get_invoiceV2/`;
      let params = `?limit=${page_size}&offset=${(page_number - 1) * 10}`;
      if (data.customer_id) params += `&customer=${data.customer_id}`;
      if (data.invoice_type) params += `&invoice_type=${data.invoice_type}`;
      if (data.invoice_status)
        params += `&status=${data.invoice_status}`;
      if (searchkey) params += `&search=${searchkey}`;
      const startDate = formatDate(
        period_start || data.period_start,
        "dd-mm-yyyy"
      );
      const endDate = formatDate(period_end || data.period_end, "dd-mm-yyyy");

      if (selectedTab !== "" && selectedTab !== "datewise") {
        params += `&search_type=${selectedTab}`;
      } else if (period_start !== "" && period_end !== "") {
        params += `&start_date=${startDate}&end_date=${endDate}`;
        params += `&search_type=datewise`;
      } else if (data.period_start !== "" && data.period_end !== "") {
        params += `&start_date=${startDate}&end_date=${endDate}`;
        params += `&search_type=datewise`;
      }

      const response = await axios.get(apiUrl + params);
      const response_data = response.data;

      if (response.status === 200) {
        const itemsArray = Array.isArray(response_data?.data?.results)
          ? response_data.data.results
          : [];
        const total_count = response_data?.data?.total ?? 0;

        setTotalRows(total_count);
        setInvoiceList(itemsArray);
        setPerPage(page_size);
        setIsLoading(false);
      } else if (response.status === 204) {
        setInvoiceList([]);
        setPageCount(0);
        setIsLoading(false);
      } else {
        triggerAlert("error", "Oops...", "Couldn't get the details");
      }
    } catch (error) {
      setIsLoading(false);
      triggerAlert("error", "Oops...", error.response.data.status || "Something went wrong..");
    }
  };

  const onSubmit = (data) => {
    setData(data);
    fetchInvoicesList(currentPage, perPage, "", data);
  };



  const handleStatusSelect = (selected) => {
    setValue("invoice_status", selected ? selected.value : null);
    if (selected !== "" || selected !== null) setIsSearchBtnDisabled(false);
    setSelectedTab("");
  };

  const downloadInvoiceAsPDF = () => {
    setTimeout(() => {
      const pdfOptions = {
        margin: 10,
        filename: `invoice.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
      };
      // html2pdf().from(htmlContent).set(pdfOptions).save();
      html2pdf().set(pdfOptions).from(reportTemplateRef2.current).save(); //for downloading hidden element
      setshowsampleInvoice(false)
      setIsLoadingSent(false)
      setdownloadsendmail(false);
    }, 1000);
  };
  const generatePDFAndSend = async (row) => {
    const pdfOptions = {
      margin: 10,
      filename: 'invoice.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
    };
    const pdfBlob = await html2pdf().set(pdfOptions).from(reportTemplateRef2.current).toPdf().output('blob');
    setshowsampleInvoice(false)
    const reader = new FileReader();
    reader.readAsDataURL(pdfBlob);  // Read the PDF Blob
    reader.onloadend = () => {
      const base64Data = reader.result.split(',')[1];
      sendInvoice(base64Data, row.id)
    };

  };
  const sendInvoice = async (base64Data, selectedInvoiceData) => {

    const api_input = {
      customer_id: customerid,
      invoice_id: selectedInvoiceData, // Use data.data as invoiceID
      type: "send_invoice",
      pdf_base_64: base64Data
    }

    try {
      const response = await axios.post(`/api/admin/send-invoice/`, api_input);
      const response_data = response.data;
      if (response_data.error_code == 200) {
        // console.log('sendInvoice', response)
        setshowsampleInvoice(false)
        triggerAlert('success', 'Success', 'Mail sent Successfully!!');
        navigate('/billing/invoice');
        setdownloadsendmail(false);
        setIsLoadingSent(false)
      }


    } catch (error) {
      setIsLoadingSent(false)
      setdownloadsendmail(false);
      console.error('Error fetching data:', error);
      triggerAlert("error", "Oops...", "Something went wrong..");

    }
  };

  const handlePageChange = page => {
    fetchInvoicesList(page, perPage, searchQuery, data);
    setCurrentPage(page);
  };



  const handleChange = (e) => {
    setSearchQuery(e.target.value);
    const searchkey = e.target.value;
    fetchInvoicesList(currentPage, perPage, searchkey, data); // Update search results on every change
  };

  useEffect(() => {
    const yesterday = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
    setValue("period_start", yesterday);
    setValue("period_end", currentDate);

    setPeriodStart(yesterday);
    setPeriodEnd(currentDate);
    setIsSearchBtnDisabled(false);
    setMinEndDate(currentDate);

    const postDate = {
      period_start: yesterday,
      period_end: currentDate,
    };
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
      obj[pair[0]] = pair[1]
    }
    if (obj.startDate && obj.endDate) {
      setValue("period_start", obj.startDate);
      setValue("period_end", obj.endDate);
      setValue("invoice_status", obj.invoice_status);
      setValue("customer_id", obj.userid);
      let postDate2 = {
        period_start: obj.startDate,
        period_end: obj.endDate,
        customer_id: obj.userid,
        invoice_status: obj.invoice_status
      };

      fetchInvoicesList(currentPage, perPage, "", postDate2);
    } else {
      fetchInvoicesList(currentPage, perPage, "", postDate);
    }



  }, []);

  useEffect(() => {
    // Calculating services cost

    if (selectedInvoice) {
      let calculatedPlansCost = 0;
      let calculatedTotalCost = 0;

      const invoiceTaxCost = parseFloat(selectedInvoice.plan_tax, 10) || 0;

      if (selectedInvoice.invoice_cat === "I") {
        selectedInvoice.plan_option.forEach((plan) => {
          const planTotal = parseFloat(plan.total) || 0;
          calculatedPlansCost += planTotal;
        });
        // calculatedTotalCost = invoiceTaxCost + calculatedPlansCost;
      } else {
        calculatedPlansCost =
          parseFloat(selectedInvoice.invoice_amount, 10) || 0;
        // calculatedTotalCost = invoiceTaxCost + calculatedPlansCost;
      }
      // Calculate tax amount based on percentage
      const taxAmount = (calculatedPlansCost * invoiceTaxCost) / 100;


      // Add tax amount to the calculatedPlansCost
      calculatedTotalCost = calculatedPlansCost + taxAmount;
      setTotalPlansCost(calculatedPlansCost);
      setInvoiceTotalCost(calculatedTotalCost);
    }

    // Download PDF logic
    // if (downloadPDF && calculatedTotalCost > 0) {
    //     downloadInvoiceAsPDF(document.getElementById('invoice-preview-card-data').innerHTML);
    //     setDownloadPDF(false); // Reset the flag after download
    // }
  }, [selectedInvoice]);


  const exportToExcel = async () => {
    setIsLoading(true);
    try {
      let apiUrl = `${api_url}billing/get_invoice_download_data`;
      let params = "?";

      const addParam = (key, value) => {
        if (value) {
          params += `${params.length > 1 ? "&" : ""}${key}=${value}`;
        }
      };

      addParam("customer_id", data.customer_id);
      addParam("invoice_type", data.invoice_type);
      addParam("invoice_status", data.invoice_status);
      addParam("keyword", searchQuery);

      const startDate = formatDate(period_start || data.period_start, "dd-mm-yyyy");
      const endDate = formatDate(period_end || data.period_end, "dd-mm-yyyy");

      if (selectedTab !== "" && selectedTab !== "datewise") {
        addParam("search_type", selectedTab);
      } else if ((period_start !== "" && period_end !== "") || (data.period_start !== "" && data.period_end !== "")) {
        addParam("start_date", startDate);
        addParam("end_date", endDate);
        addParam("search_type", "datewise");
      }


      const response = await axios.get(apiUrl + params, token);
      const response_data = response.data;
      if (response_data.error_code === 200) {
        const itemsArray = response_data.results;
        exportToCsv(itemsArray, 'invoice_report');
        setIsLoading(false);
      } else if (response.status === 204) {
        setIsLoading(false);
      } else {
        triggerAlert('error', 'Oops...', "Couldn't export the file");
      }
    } catch (error) {
      //console.log(error)
      setIsLoading(false);
      triggerAlert("error", "Oops...", "Something went wrong..");
    }
  }
  const handlePerRowsChange = async (newPerPage, page) => {
    fetchInvoicesList(page, newPerPage, searchQuery, data);
    setPerPage(newPerPage);
  };
  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All',
  };
  const handleReset = () => {
    fetchInvoicesList(1, 10, '', {
      customer_id: null,
      invoice_type: null,
      invoice_status: null,
      period_start: null,
      period_end: null,
    });
    reset({
      period_start: null,
      period_end: null,
      customer_id: null,
      invoice_status: null,
    });
    setValue("customer_id", null);
    setPeriodStart(null);
    setPeriodEnd(null);
    setMinEndDate(null);
    setcustomerId(null);
    setIsSearchBtnDisabled(true);
    setSelectedTab("");
  };

  return (
    <>
      <div id="layout-wrapper">
        <Header />
        <Sidebar />

        {/* <!-- ============================================================== -->
                <!-- Start right Content here -->
                <!-- ============================================================== --> */}
        <div className="main-content">
          <div className="page-content" style={{ backgroundColor: "#ededed" }}>
            <div className="container-fluid" >
              <PageHeader mainHeading={mainHeading} heading={heading} />
              {sendInvoiceId && sendCustomerId && (
                <PdfGen
                  id={sendInvoiceId}
                  type="send_invoice"
                  customer_id={sendCustomerId}
                />
              )}
              {/* Render YourComponent if apiData is available */}
              {isLoadingSent ? (
                <div className="loader-overlay text-white">
                  <Loader />
                </div>
              ) : null}
              {!showsampleInvoice && (
                <>
                  <div className="row   ">
                    <div className="col-xl-12">
                      <div className="">
                        <div className="card-body">
                          {/* Tab panes*/}

                          <form
                            data-select2-id="21"
                            noValidate="novalidate"
                            onSubmit={handleSubmit(onSubmit)}
                          >
                            <div className="row g-3" data-select2-id="20">
                              <div className="col-md-2  d-flex flex-column">
                                <label className="form-label">From</label>
                                <Controller
                                  className="px-3"
                                  control={control}
                                  name="period_start"
                                  render={({ field }) => (
                                    <DatePicker
                                      className="px-3 form-control"
                                      placeholderText="MM/DD/YYYY"
                                      selected={field.value}
                                      {...register("period_start")}
                                      onChange={(date) => {
                                        setPeriodStart(date);
                                        field.onChange(date);
                                        setMinEndDate(date); // Update minDate for period_end
                                        setIsSearchBtnDisabled(
                                          !date || !period_end
                                        );
                                        if (date) setSelectedTab("datewise");
                                      }}
                                      showMonthDropdown
                                      showYearDropdown
                                      maxDate={new Date()}
                                      autoComplete="off"
                                    />
                                  )}
                                />
                                {errors.period_start && (
                                  <div
                                    style={{
                                      color: "red",
                                      fontSize: "14px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {errors.period_start.message}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-2  d-flex flex-column">
                                <label className="form-label">To</label>
                                <Controller
                                  control={control}
                                  name="period_end"
                                  render={({ field }) => (
                                    <DatePicker
                                      className="px-3 form-control"
                                      placeholderText="MM/DD/YYYY"
                                      selected={field.value}
                                      {...register("period_end")}
                                      onChange={(date) => {
                                        setPeriodEnd(date); // Update the state variable
                                        field.onChange(date); // Update the form value
                                        setIsSearchBtnDisabled(
                                          !period_start || !date
                                        );
                                        if (date) setSelectedTab("datewise");
                                      }}
                                      showMonthDropdown
                                      showYearDropdown
                                      maxDate={new Date()}
                                      minDate={minEndDate}
                                      autoComplete="off"
                                    />
                                  )}
                                />
                                {errors.period_end && (
                                  <div
                                    style={{
                                      color: "red",
                                      fontSize: "14px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {errors.period_end.message}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-2" style={{ zIndex: 10 }}>
                                <label
                                  className="form-label"
                                  htmlFor="formtabs-first-name"
                                >
                                  Username
                                </label>
                                {/* <AutoUserSearch onSelect={handleUserSelect} /> */}
                                <Controller
                                  name="customer_id"
                                  {...register(
                                    "customer_id"
                                    // , { required: 'User is required' }
                                  )}
                                  control={control}
                                  render={({ field }) => (
                                    <AutoUserSearch
                                      onSelect={(user) => {
                                        setValue(
                                          "customer_id",
                                          user ? user.user_id : null
                                        );
                                        setcustomerId(
                                          user ? user.user_id : null
                                        );
                                      }} value={field.value}
                                    />
                                  )}
                                />
                                {errors.customer_id && (
                                  <div
                                    style={{
                                      color: "red",
                                      fontSize: "14px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {errors.customer_id.message}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-2" style={{ zIndex: 10 }}>
                                <label
                                  className="form-label"
                                  htmlFor="invoice_status"
                                >
                                  Payment Status
                                </label>
                                <Controller
                                  name="invoice_status"
                                  {...register(
                                    "invoice_status"
                                    // , { required: 'Status is required' }
                                  )}
                                  control={control}
                                  render={({ field }) => (
                                    <CommonSelect
                                      options={invoiceStatus}
                                      value={field.value}
                                      // onChange={(value) => field.onChange(value)}
                                      onChange={handleStatusSelect}
                                      placeholder="Select Status"
                                    />
                                  )}
                                />
                                {errors.invoice_status && (
                                  <div
                                    style={{
                                      color: "red",
                                      fontSize: "14px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {errors.invoice_status.message}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-2">
                                <label
                                  className="form-label"
                                  htmlFor="formtabs-last-name"
                                >
                                  &nbsp;
                                </label>
                                <div className="button-items d-flex gap-2">
                                  <button
                                    type="submit"
                                    className="btn btn-primary w-md"
                                    disabled={isSearchBtnDisabled}
                                  >
                                    Search
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-warning w-md"
                                    disabled={isSearchBtnDisabled}
                                    onClick={handleReset}
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>



                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12">
                      <div className=" mb-2">
                        <div className="">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 mb-2 d-flex justify-content-end">
                              {exportPermission && invoiceList.length > 0 &&
                                <button type="button" className="btn btn-success w-md" onClick={exportToExcel}>Export to Excel</button>
                              }
                              <div className="btn-group float-end ms-3">
                                <input
                                  type="search"
                                  placeholder="Search..."
                                  value={searchQuery}
                                  className="form-control form-control-sm"
                                  aria-controls="example"
                                  onChange={handleChange}
                                  style={{ borderRadius: '7px' }}
                                />
                                &nbsp;&nbsp;
                              </div>
                            </div>

                          </div>

                          {!isLoading ?
                            <DataTable
                              columns={columns}
                              data={invoiceList}
                              pagination
                              paginationServer
                              fixedHeaderScrollHeight='620px'
                              fixedHeader
                              persistTableHead
                              paginationTotalRows={totalRows}
                              customStyles={customStyles}
                              paginationPerPage={perPage}
                              paginationComponentOptions={paginationComponentOptions}
                              paginationDefaultPage={currentPage}

                              onChangeRowsPerPage={handlePerRowsChange}
                              onChangePage={handlePageChange}
                            /> :
                            <div className='loader-overlay text-white'>
                              <Loader />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {(showsampleInvoice || downloadsendmail) && (
                <>
                  <div className="d-flex justify-content-end mb-1">
                    <Button size="small" title="Close" onClick={() => { setshowsampleInvoice(false); setdownloadsendmail(false); }}  >   back </Button>
                  </div>

                  <Card sx={{ p: 3 }} ref={showsampleInvoice ? reportTemplateRef : reportTemplateRef2}>
                    <Box>

                      {/* HEADER */}
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", md: "1fr auto 1fr" },
                          alignItems: "start",
                          gap: 2,
                          mb: 3,
                          mx: 4,
                          my: 3,
                        }}
                      >
                        {/* LEFT */}
                        <Box sx={{ marginLeft: 1 }} fontSize={13}>
                          <img src="/assets/images/spg_logo.png" alt="Logo" style={{ width: 120 }} />

                          <Typography fontWeight={500} fontSize={15} mt={1}>
                            SPG America
                          </Typography>

                          <Typography variant="body2" color="#464a4d" fontSize={13}>
                            15 Corporate Pl S #421
                          </Typography>

                          <Typography variant="body2" color="#464a4d" fontSize={13}>
                            Piscataway, NJ 08854, United States
                          </Typography>

                          <Typography variant="body2" color="#464a4d" fontSize={13}>
                            careers@spgamerica.com
                          </Typography>
                          <Typography variant="body2" color="#464a4d" fontSize={13}>
                            +1 732-343-7688
                          </Typography>

                        </Box>

                        {/* CENTER */}
                        <Box textAlign="center" alignSelf="center">
                          <img src="/assets/images/logoblack.png" alt="Logo" style={{ width: 220 }} />
                          <Typography variant="h5" fontWeight={500} mt={1}>
                            Invoice
                          </Typography>
                        </Box>

                        {/* RIGHT */}
                        <Box textAlign="right" sx={{ marginTop: 6 }}>
                          <Typography variant="body2">
                            <strong>Invoice Number:</strong>{" "}
                            {selectedInvoiceData?.invoice_number || selectedInvoiceData?.id || "--"}
                          </Typography>

                          <Typography variant="body2">
                            <strong>Date:</strong>{" "}
                            {selectedInvoiceData?.invoice_date
                              ? dayjs(selectedInvoiceData.invoice_date).format("MM/DD/YYYY")
                              : selectedInvoiceData?.created_at
                                ? dayjs(selectedInvoiceData.created_at).format("MM/DD/YYYY")
                                : "--"}
                          </Typography>
                        </Box>
                      </Box>

                      <Box mx={4}>
                        {/* CUSTOMER INFO */}
                        <Box border="2px solid #efeff1" borderRadius={3} p={2} mb={4} >
                          <Typography variant="h6" fontWeight={600} color="#464a4d" textAlign="center" mb={2}>
                            Customer Information
                          </Typography>

                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                            <Box sx={{ flexBasis: { xs: '100%', sm: '50%' } }}>
                              <Typography variant="body2">Company Name :</Typography>
                              <Typography variant="body2">Contact Name :</Typography>
                              <Typography variant="body2">Email Id :</Typography>
                              <Typography variant="body2">Address :</Typography>
                              <Typography variant="body2">Phone :</Typography>
                            </Box>

                            <Box sx={{ flexBasis: '40%' }} >
                              <Typography variant="body2">
                                {selectedInvoiceData?.organization__name || "—"}
                              </Typography>
                              <Typography variant="body2">
                                {selectedInvoiceData?.customer_name || selectedInvoiceData?.user_name || "—"}
                              </Typography>
                              <Typography variant="body2">
                                {selectedInvoiceData?.email || selectedInvoiceData?.user_email || "—"}
                              </Typography>
                              <Typography variant="body2">
                                {selectedInvoiceData?.billing_info?.address_line_1
                                  ? `${selectedInvoiceData.billing_info.address_line_1} ${selectedInvoiceData.billing_info.address_line_2 || ''} ${selectedInvoiceData.billing_info.city || ''}, ${selectedInvoiceData.billing_info.state || ''} ${selectedInvoiceData.billing_info.postal_code || ''}`.trim()
                                  : "—"}
                              </Typography>
                              <Typography variant="body2">
                                {selectedInvoiceData?.billing_info?.phone || "—"}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>

                        {/* BILLING TABLE */}
                        <Box>
                          <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                              <tr style={{ backgroundColor: "#004466", color: "#fff" }}>
                                <th align="left" style={{ padding: 12 }}>S.NO</th>
                                <th align="left" style={{ padding: 12 }}>PLAN TYPE</th>
                                <th align="left" style={{ padding: 12 }}>DESCRIPTION</th>
                                <th align="center" style={{ padding: 12 }}>QUANTITY</th>
                                <th align="center" style={{ padding: 12 }}>UNIT PRICE</th>
                                <th align="right" style={{ padding: 12 }}>PRICE</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td style={{ padding: 12 }}>1</td>
                                <td style={{ padding: 12 }}>
                                  {selectedInvoiceData?.plan_details?.plan_type
                                    || (selectedInvoiceData?.transaction_type
                                      ? selectedInvoiceData.transaction_type.charAt(0).toUpperCase() + selectedInvoiceData.transaction_type.slice(1)
                                      : "--")}
                                </td>
                                <td style={{ padding: 12 }}>
                                  {selectedInvoiceData?.plan_details?.plan_description || selectedInvoiceData?.description || "--"}
                                </td>
                                <td align="center" style={{ padding: 12 }}>
                                  {selectedInvoiceData?.plan_details?.quantity || "--"}
                                </td>
                                <td align="center" style={{ padding: 12 }}>
                                  {selectedInvoiceData?.plan_details?.plan_price != null
                                    ? `$${selectedInvoiceData.plan_details.plan_price.toFixed(2)}`
                                    : "--"}
                                </td>
                                <td align="right" style={{ padding: 12 }}>
                                  {selectedInvoiceData?.subtotal != null
                                    ? `$${selectedInvoiceData.subtotal.toFixed(2)}`
                                    : selectedInvoiceData?.amount
                                      ? `$${parseFloat(selectedInvoiceData.amount).toFixed(2)}`
                                      : "--"}
                                </td>
                              </tr>

                              <tr>
                                <td colSpan={6}>
                                  <Box width={320} ml="auto" mt={2}>
                                    <Box display="flex" justifyContent="space-between">
                                      <Typography>Tax</Typography>
                                      <Typography>
                                        {selectedInvoiceData?.tax != null
                                          ? `$${selectedInvoiceData.tax.toFixed(2)}`
                                          : "--"}
                                      </Typography>
                                    </Box>

                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                      mt={1}
                                      borderTop="1px solid #ddd"
                                      pt={1}
                                    >
                                      <Typography fontWeight={700}>GRAND TOTAL</Typography>
                                      <Typography fontWeight={700}>
                                        {selectedInvoiceData?.total != null
                                          ? `$${selectedInvoiceData.total.toFixed(2)}`
                                          : selectedInvoiceData?.amount
                                            ? `$${parseFloat(selectedInvoiceData.amount).toFixed(2)}`
                                            : "--"}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Box>
                      </Box>

                      {/* FOOTER */}
                      <Box textAlign="center" mt={4} py={2}>
                        <Typography
                          variant="h6">
                          Thank You for Your Purchase!
                        </Typography>
                      </Box>

                      {/* DOWNLOAD BUTTON (ONLY FOR PREVIEW) */}
                      {/* {showsampleInvoice && (
                      <Box display="flex" justifyContent="center" mt={3}>
                        <Button
                          startIcon={<PictureAsPdf />}
                          variant="contained"
                        onClick={handleDownloadPDF}
                        >
                          Download PDF
                        </Button>
                      </Box>
                    )} */}

                    </Box>
                  </Card>
                </>
              )}
            </div>
            {/* <!-- container-fluid --> */}
          </div>
          {/* <!-- End Page-content --> */}

          <Footer />
        </div>
        {/* <!-- end main content--> */}
      </div>
      {/* <!-- END layout-wrapper*/}

      {/* <!-- Right bar overlay--> */}
      <div className="rightbar-overlay"></div>
    </>
  );
}
